import { render, staticRenderFns } from "./aprobarRechazarCompromisoPago.vue?vue&type=template&id=71bb40b0&scoped=true"
import script from "./aprobarRechazarCompromisoPago.vue?vue&type=script&lang=js"
export * from "./aprobarRechazarCompromisoPago.vue?vue&type=script&lang=js"
import style0 from "./aprobarRechazarCompromisoPago.vue?vue&type=style&index=0&id=71bb40b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71bb40b0",
  null
  
)

export default component.exports